import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { resetPassword } from '../../services/auth.services'

export function ResetPasswordPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token') ?? ''
  const userId = searchParams.get('userId') ?? ''

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const hasValidLink = Boolean(token && userId)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSuccessMessage('')

    if (!hasValidLink) {
      setError('လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်ရန် လင့်ခ်မမှန်ကန်ပါ။')
      return
    }

    if (password.length < 8) {
      setError('လျှို့ဝှက်နံပါတ်ကို အနည်းဆုံး ၈ လုံး ရိုက်ထည့်ပါ။')
      return
    }

    if (password !== confirmPassword) {
      setError('လျှို့ဝှက်နံပါတ် နှစ်ခု မတူညီပါ။')
      return
    }

    setIsLoading(true)

    try {
      await resetPassword({
        userId,
        token,
        password,
      })

      setSuccessMessage('လျှို့ဝှက်နံပါတ်ကို အောင်မြင်စွာ ပြန်လည်သတ်မှတ်လိုက်ပါပြီ။ အကောင့်ဝင်ရန်စာမျက်နှာသို့ ပြန်သွားပါမည်။')
      setPassword('')
      setConfirmPassword('')

      window.setTimeout(() => {
        navigate('/')
      }, 2000)
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message)
      } else {
        setError('လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်ရာတွင် အမှားရှိနေပါသည်။')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-10">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-xl">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900">လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်ရန်</h1>
          <p className="mt-2 text-sm text-slate-600">
            {hasValidLink
              ? 'အသစ်သော လျှို့ဝှက်နံပါတ် ကို ရိုက်ထည့်ပြီး အတည်ပြုပါ။'
              : 'သင့် လင့်ခ်သည် သက်တမ်းကုန်သွားသို့မဟုတ် မှန်ကန်မှုမရှိပါ။'}
          </p>
        </div>

        {!hasValidLink ? (
          <div className="mt-6 space-y-4">
            <p className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error || 'တောင်းဆိုထားသော Reset Link ကို အသုံးပြု၍ မရပါ။'}
            </p>
            <button
              type="button"
              onClick={() => navigate('/')}
              className="flex w-full items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md hover:bg-blue-500 transition-colors"
            >
              အကောင့်ဝင်ရန်စာမျက်နှာသို့ ပြန်သွားမည်
            </button>
          </div>
        ) : (
          <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-slate-700">
                လျှို့ဝှက်နံပါတ်အသစ်
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
                className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2.5 text-slate-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
                placeholder="အသစ်သော လျှို့ဝှက်နံပါတ်"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-slate-700">
                လျှို့ဝှက်နံပါတ် အတည်ပြုရန်
              </label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={isLoading}
                className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2.5 text-slate-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
                placeholder="လျှို့ဝှက်နံပါတ်ကို ထပ်မံရိုက်ထည့်ပါ"
              />
            </div>

            {error && <p className="text-sm font-medium text-red-600">{error}</p>}
            {successMessage && <p className="text-sm font-medium text-emerald-600">{successMessage}</p>}

            <button
              type="submit"
              disabled={isLoading}
              className="flex w-full items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md hover:bg-blue-500 transition-colors disabled:opacity-50"
            >
              {isLoading ? 'ဆောင်ရွက်နေပါသည်...' : 'လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်မည်'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
